import { factory } from '@wix/web-bi-logger';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
import { omitValues } from '@wix/cashier-common/dist/src/utils/omitValues';
import { wixSdkAdapter } from './wixSdkAdapter';

// @wix/iframe-app-bi-logger - doesn't have types
type Factory = ReturnType<typeof factory>;
type Logger = ReturnType<Factory['logger']>;
type BIDefaults = { [key: string]: any | (() => any) };

let biDefaults: BIDefaults = omitValues(
  {
    msid: wixSdkAdapter.getMetasiteId(),
    memberId: wixSdkAdapter.getMemberId(),
    visitorId: wixSdkAdapter.getVisitorId(),
  },
  [null],
);

export const updateBiDefaults = (defaults: BIDefaults): void => {
  biDefaults = {
    ...biDefaults,
    ...defaults,
  };
};

export const getBiLogger = (): Logger => iframeAppBiLoggerFactory(window.Wix).updateDefaults(biDefaults).logger();
